import { FC, ReactNode } from "react";
import { motion } from "framer-motion";

import { useCache } from "../utils/useCache";

export interface SimpleFadeInProps {
  children: ReactNode;
  className?: string;
}

export const SimpleFadeIn: FC<SimpleFadeInProps> = ({ children, className }) => {
  const { nextStepAnimationSkip } = useCache();

  return (
    <motion.div
      className={className || undefined}
      initial={{
        y: nextStepAnimationSkip ? 0 : 100,
        opacity: nextStepAnimationSkip ? 1 : 0,
      }}
      animate={{
        y: 0,
        opacity: 1
      }}
      transition={{
        duration: 0.3,
        ease: [0.19, 1, 0.22, 1]
      }}
    >
      {children}
    </motion.div>
  )
};